import { PixelCrop } from 'react-image-crop';

/**
 * Функция для отрисовки предпросмотра обрезанного изображения на canvas.
 *
 * @param {HTMLImageElement} image - Изображение, которое нужно обрезать.
 * @param {HTMLCanvasElement} canvas - Canvas элемент, на котором будет отрисован предпросмотр.
 * @param {PixelCrop} crop - Параметры кадрирования в пикселях.
 * @returns {Promise<void>} Promise, который разрешается после завершения отрисовки.
 * @throws {Error} Если не удалось получить 2d контекст canvas.
 */

export const canvasPreview = async (
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: PixelCrop,
) => {
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const pixelRatio = 1;

  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = 'high';

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  ctx.drawImage(
    image,
    cropX,
    cropY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY,
  );
};
